import axios from 'axios';

export default class SubscriptionsCategoriesService
{
    public static path = 'admin/cms/subscriptions/categories';

    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<ListItemModel>>(`${this.path}`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async getAll()
    {
        return (await axios.get<Resource<ListItemModel[]>>(`${this.path}/all`)).data;
    }

    public static async getAutocompleteList(search: string, limit: number = 20)
    {
        const { data } = await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                limit: limit
            }
        });

        return data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        const { data } = await axios.get<ListItemModel[]>(`${this.path}/autocomplete/${id}`);

        return data.first();
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`${this.path}/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<FormModel>(`${this.path}`, model)).data;
    }

    public static async update(model: FormModel)
    {
        return (await axios.put<Statement>(`${this.path}/${model.id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`${this.path}/${id}`)).data as Statement;
    }
}

export interface ListItemModel
{
    id: number;
    name: string;
    position: number;
}

export interface FilterModel
{
    name: string;
}

export interface FormModel
{
    id: number;
    name: string;
    position: number;
}
